import React from 'react'
import { titleCase } from 'change-case'
import Linkify from 'react-linkify'
import './listingErrors.scss'

interface Props {
  errors: any
}
const ListingErrors: React.FC<Props> = ({ errors }) => {
  if (!errors) return null
  if (typeof errors === 'string') return <Linkify>{errors}</Linkify>
  if (typeof errors !== 'object' || Object.keys(errors).length === 0) return null

  return (
    <ul className="tooltip-listing-error">
      {Object.keys(errors).map(err => (
        <li key={err}>
          <strong>{titleCase(err)}</strong>{' '}
          <Linkify>{Array.isArray(errors[err]) ? errors[err].join(', ') : JSON.stringify(errors[err])}</Linkify>
        </li>
      ))}
    </ul>
  )
}
export default ListingErrors
